import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  selectDrugAdviceEntity,
  selectDrugAdviceTypesData,
  setDrugAdviceTypesData,
  setDrugAdviceTypesError,
  setDrugAdviceTypesState,
  setEntityData,
  setEntityError,
  setEntityState,
} from '../prescriptionReducer'
import {
  HE_DRUG_ADVICE_TYPE,
  REDUX_STATUS_FAILED,
  REDUX_STATUS_LOADING,
} from 'src/consumer/constants'
import {
  getHealthEntityResponse,
  getOrderedDrugAdviceItemOptions,
} from 'src/mentor/components/PrescriptionMakingPage/utils'

export const fetchDrugAdviceTypes = createAsyncThunk(
  'prescriptionStore/fetchDrugAdviceTypes',
  async ({ force = false, clinicBrandId }, { getState, dispatch }) => {
    const state = getState()
    const existingData = selectDrugAdviceTypesData(state)?.data
    // If data exists, update state to 'success' and continue silently
    if (existingData && existingData.length > 0) {
      dispatch(setDrugAdviceTypesData(existingData))
      if (!force) {
        return existingData
      }
    } else {
      dispatch(setDrugAdviceTypesState(REDUX_STATUS_LOADING))
    }

    const response = await getHealthEntityResponse({
      healthEntityParam: HE_DRUG_ADVICE_TYPE,
      params: { clinicBrandId },
    })
    if (response?.status === 200) {
      const orderedDrugTypes = getOrderedDrugAdviceItemOptions({
        drugAdviceItemOptions: response?.data,
      })
      dispatch(setDrugAdviceTypesData(orderedDrugTypes))
      return orderedDrugTypes
    } else {
      dispatch(setDrugAdviceTypesError(response.message || 'Failed to fetch data'))
      dispatch(setDrugAdviceTypesState(REDUX_STATUS_FAILED))
    }
  },
)

export const fetchDrugAdviceEntity = createAsyncThunk(
  'prescriptionStore/fetchDrugAdviceEntity',
  async ({ entity, force = false, clinicBrandId }, { getState, dispatch }) => {
    const state = getState()
    const existingData = selectDrugAdviceEntity(entity)(state)?.data

    // If data exists, update state to 'success' and continue silently
    if (existingData && existingData.length > 0) {
      dispatch(setEntityData({ entity, data: existingData }))
      if (!force) {
        return existingData
      }
    } else {
      dispatch(setEntityState({ entity, status: REDUX_STATUS_LOADING }))
    }

    const response = await getHealthEntityResponse({
      healthEntityParam: entity, // Dynamically passing entity
      params: { clinicBrandId },
    })

    if (response?.status === 200) {
      const orderedData = getOrderedDrugAdviceItemOptions({
        drugAdviceItemOptions: response?.data,
      })
      dispatch(setEntityData({ entity, data: orderedData }))
      return orderedData
    } else {
      dispatch(setEntityError({ entity, error: response.message || 'Failed to fetch data' }))
      dispatch(setEntityState({ entity, status: REDUX_STATUS_FAILED }))
    }
  },
)
